import { render } from "./ReceivePaymentList.vue?vue&type=template&id=2203cc7a&scoped=true"
import script from "./ReceivePaymentList.vue?vue&type=script&lang=js"
export * from "./ReceivePaymentList.vue?vue&type=script&lang=js"

import "./ReceivePaymentList.vue?vue&type=style&index=0&id=2203cc7a&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2203cc7a"]])

export default __exports__